let runTimeOut;
const timeRunning = 2000;

const getElementRect = (element) => element.getBoundingClientRect();

const getThumbnailPosition = (thumbnail, relativeTo) => {
	const thumbnailRect = getElementRect(thumbnail);
	const relativeRect = getElementRect(relativeTo);

	return {
		left: thumbnailRect.left - 16 - relativeRect.left,
		bottom: thumbnailRect.bottom - relativeRect.bottom,
		top: relativeRect.height - 16 - thumbnailRect.height,
	};
};

const updateSliderDimensions = (slider, firstElement) => {
	const sliderRect = getElementRect(firstElement);

	slider.style.setProperty("--original-height", `${sliderRect.height}px`);
};

const moveSlider = (direction) => {
	const slider = document.querySelector(".wp-block-leviosa-leviosa-image-slider");
	const sliderContentWrapper = document.querySelector(".wp-block-leviosa-leviosa-image-slider__content");
	const sliderElements = document.querySelectorAll(".wp-block-leviosa-leviosa-image-slide");
	const thumbnailImages = document.querySelectorAll(".wp-block-leviosa-leviosa-image-slider__thumbnails img");
	const thumbnailWrapper = document.querySelector(".wp-block-leviosa-leviosa-image-slider__thumbnails");

	if (direction === "forwards") {
		thumbnailWrapper.appendChild(thumbnailImages[0]);
		sliderContentWrapper.appendChild(sliderElements[0]);
		slider.classList.add("next");
	} else if (direction === "backwards") {
		sliderContentWrapper.prepend(sliderElements[sliderElements.length - 1]);
		thumbnailWrapper.prepend(thumbnailImages[thumbnailImages.length - 1]);
		slider.classList.add("prev");
	}

	clearTimeout(runTimeOut);
	runTimeOut = setTimeout(() => {
		slider.classList.remove("next");
		slider.classList.remove("prev");
	}, timeRunning);
};

document.addEventListener("DOMContentLoaded", function () {
	const nextButton = document.querySelector(".wp-block-leviosa-leviosa-image-slider__buttons .next");
	const prevButton = document.querySelector(".wp-block-leviosa-leviosa-image-slider__buttons .prev");
	const images = document.querySelectorAll(".wp-block-cover__image-background");

	const slider = document.querySelector(".wp-block-leviosa-leviosa-image-slider");
	const sliderElements = document.querySelectorAll(".wp-block-leviosa-leviosa-image-slide");
	const thumbnailWrapper = document.querySelector(".wp-block-leviosa-leviosa-image-slider__thumbnails");
	const firstCover = sliderElements[0].querySelector(".wp-block-cover");

	if (sliderElements.length > 0) {
		setTimeout(() => {
			updateSliderDimensions(slider, firstCover);
		}, 50);
	}

	images.forEach((thumbnail) => {
		const thumbnailImage = thumbnail.cloneNode(true);
		thumbnailWrapper.appendChild(thumbnailImage);
	});

	sliderElements.forEach((slide) => {
		const coverContent = slide.querySelectorAll(".wp-block-cover__inner-container");
		coverContent.forEach((content) => {
			coverChildElements = content.children;

			for (let i = 0; i < coverChildElements.length; i++) {
				coverChildElements[i].style.setProperty("--animation-delay", `${0.6 + i * 0.2}s`);
			}
		});
	});

	const thumbnailImages = document.querySelectorAll(".wp-block-leviosa-leviosa-image-slider__thumbnails img");
	thumbnailWrapper.appendChild(thumbnailImages[0]);

	if (thumbnailImages.length > 1) {
		const firstThumbnailPosition = getThumbnailPosition(thumbnailImages[1], firstCover);
		slider.style.setProperty("--thumbnail-left", `${firstThumbnailPosition.left}px`);
		slider.style.setProperty("--thumbnail-top", `${firstThumbnailPosition.top}px`);
	}

	nextButton?.addEventListener("click", () => moveSlider("forwards"));
	prevButton?.addEventListener("click", () => moveSlider("backwards"));
});
